import React from 'react';

export default function Loader() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
      <div
        style={{
          width: 40,
          height: 40,
          border: '4px solid var(--bj-sand)',
          borderTopColor: 'var(--bj-clay)',
          borderRadius: '50%',
          animation: 'bj-spin 0.8s linear infinite'
        }}
      />
      <style>{`@keyframes bj-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
